<template>
  <div class="tabbar">
    <van-tabbar fixed route placeholder active-color="#3BE199" inactive-color="#E0E0E0" :before-change="beforeChange">
      <van-tabbar-item replace v-for="item in navList" :key="item.path" :to="item.path">
        <span>{{ item.name }}</span>
        <template #icon="props">
          <img :src="props.active ? item.activeIcon : item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <van-overlay :show="show" @click="show = false">
      <div class="tips-wrapper" @click.stop>
        <div class="dialog__title">
          Tips
        </div>
        <div class="dialog__content">
          Please register or log in first
        </div>
        <div class="dialog__footer">
          <div class="flex justify-between">
            <div class="cancel" @click="show = false">Cancel</div>
            <div class="confirm flex">
              <div @click="$router.push('login')">Log in</div>
              <div style="margin-left: 25px;" @click="$router.push('welcome')">Register</div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      show: false,
      navList: [
        {
          name: this.$t('tab.home'),
          path: '/home',
          icon: require('@/assets/images/icon/operation.png'),
          activeIcon: require('@/assets/images/icon/operation_a.png')
        },
        {
          name: this.$t('tab.statistics'),
          path: '/statistics',
          icon: require('@/assets/images/icon/statistics.png'),
          activeIcon: require('@/assets/images/icon/statistics_a.png')
        },
        {
          name: this.$t('tab.mine'),
          path: '/mine',
          icon: require('@/assets/images/icon/me.png'),
          activeIcon: require('@/assets/images/icon/me_a.png')
        }
      ]
    }
  },
  computed: {
    ...mapState({
      token: state => state.user.token
    })
  },
  methods: {
    beforeChange () {
      console.log(this.token)
      if (this.token) {
        return true
      } else {
        this.show = true
        return false
      }
    }
  }
}
</script>

<style lang="less">
  .tips-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    min-height: 260px;
    background: #fff;
    overflow: hidden;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .dialog__title {
      font-size: 40px;
      font-weight: bold;
    }
    .dialog__content {
      font-size: 28px;
      p {
        padding: 20px 0;
        line-height: 2;
      }
    }
    .dialog__footer {
      font-weight: bold;
      font-size: 28px;
      color: #1989fa;
    }
  }
</style>